import logoHorizontal from '../assets/reseptio_logo_1080.png';
import logoIcon from '../assets/reseptio_profil_1080.png';

// Yatay logo (sembol + "Reseptio" yazısı)
export function ReseptioLogoFull({ height = 32, style = {} }) {
  return (
    <img
      src={logoHorizontal}
      alt="Reseptio"
      style={{ height, width: 'auto', display: 'block', objectFit: 'contain', ...style }}
    />
  );
}

// Sadece sembol (kare ikon)
export function ReseptioIcon({ size = 32, style = {} }) {
  return (
    <img
      src={logoIcon}
      alt="Reseptio"
      style={{ width: size, height: size, display: 'block', objectFit: 'contain', ...style }}
    />
  );
}
